import * as React from 'react';
import Grid, {GridProps} from '@material-ui/core/Grid';
import ArrowRightBold from 'mdi-material-ui/ArrowRightBold';
import CheckIcon from '@material-ui/icons/Check';

export interface GridFormRowProp extends GridProps {
  checked?: boolean;
  left: React.ReactNode;
  right: React.ReactNode;
  showArrow?: boolean;
}

const GridFormRow: React.FunctionComponent<GridFormRowProp> = ({left, right, checked, showArrow, ...props}) => {
  return (
    <Grid container spacing={2} alignItems="center" {...props}>
      <Grid item xs={1}>
        {checked ? <CheckIcon color="primary" /> : undefined}
      </Grid>
      <Grid item xs={5}>
        {left}
      </Grid>
      <Grid item xs={1}>
        {showArrow && <ArrowRightBold color="disabled" />}
      </Grid>
      <Grid item xs={5}>
        {right}
      </Grid>
    </Grid>
  );
};

GridFormRow.defaultProps = {
  showArrow: true,
};

export default GridFormRow;
